// @flow
import {
  GET_DATA,
  ADD,
  UPDATE,
  DELETE,
  SET_INITIALIZED_DATA,
  ADD_SELECTED_ROW,
  DELETE_SELECTED_ROW,
  SET_SELECTED_ROWS,
  SET_FILTERS,
  SET_SORTERS,
} from "../actions/users";

let dataState = { 
  data: [], count: 0, limit: 0,
  initializedData: false,
  selectedRows: [],
  filters: {},
  sorters: {},
};

const UsersReducer = (state = dataState, action) => {
  let newdata, index;

  switch (action.type) {
    case GET_DATA:
      newdata = Object.assign({}, state);
      newdata.data = action.payload;
      state = Object.assign({}, state, newdata);
      return state;

    case ADD:
      return {
        ...state,
        data: [...state.data, action.payload],
      };

    case UPDATE:
      const newArray = [...state.data];
      index = state.data.findIndex((object) => {
        return object.id === action.id;
      });
      if (index !== -1) {
        newArray[index] = action.payload;
      }
      return {
        ...state,
        data: newArray,
      };

    case DELETE:
      return {
        ...state,
        data: state.data.filter((el) => el.id !== action.id),
      };

    case SET_INITIALIZED_DATA:
      newdata = Object.assign({}, state);
      newdata.initializedData = action.payload;
      state = Object.assign({}, state, newdata);
      return state;

    case ADD_SELECTED_ROW:
      return {
        ...state,
        selectedRows: [...state.selectedRows, action.payload],
      };

    case DELETE_SELECTED_ROW:
      return {
        ...state,
        selectedRows: state.selectedRows.filter((el) => el.id !== action.id),
      };

    case SET_SELECTED_ROWS:
      newdata = Object.assign({}, state);
      newdata.selectedRows = action.payload;
      state = Object.assign({}, state, newdata);
      return state;
      
    case SET_FILTERS:
      newdata = Object.assign({}, state);
      newdata.filters = action.payload;
      state = Object.assign({}, state, newdata);
      return state;

    case SET_SORTERS:
      newdata = Object.assign({}, state);
      newdata.sorters = action.payload;
      state = Object.assign({}, state, newdata);
      return state;

    default:
      return state;
  }
};

export default UsersReducer;
